<template>
	<div class="uk-container">
		<h1>Vielen Dank für deine Anmeldung!</h1>

		<p>Deine neue Website ist bereits startklar:</p>

		<span uk-icon="link"></span>&nbsp;<a v-bind:href="url" target="_blank">{{ url }}</a>

		<p>
			Wir haben gerade eine E-Mail an die Adresse <strong>{{ email }}</strong> gesendet.
		</p>

		<div class="action-content-section uk-margin-large uk-padding-small uk-flex">
			<div class="uk-flex-none"><span uk-icon="mail"></span>&nbsp;</div>
			<div>
				Bitte prüfe nun deinen Posteingang und bestätige
				<strong>innerhalb der kommenden 48 Stunden</strong>	deine
				Anmeldung und Mailadresse per Klick auf den in dieser Nachricht
				enthaltenen Link!
			</div>
		</div>

		<p class="error-notice uk-margin-large-bottom uk-padding-small" v-if="imageUploadErrors">
			Beim Hinzufügen deines Logos oder Fotos ist leider ein Problem aufgetreten.<br>
			<strong>Wir kümmern uns schnellstmöglich darum!</strong>
		</p>

		<p>
			E-Mail nicht erhalten oder Mailadresse falsch?<br>
			<span uk-icon="mail"></span>&nbsp;<a href="mailto:hilfe@immonex.one">hilfe@immonex.one</a>
		</p>
	</div>
</template>

<script>
export default {
	name: 'signup-result',
	props: ['url', 'email', 'imageUploadErrors'],
	mounted () {
		if (!this.url || !this.email) this.$router.replace({ name: 'home' })
	}
}
</script>

<style lang="scss" scoped>
.error-notice {
	max-width: 50em;
	color: #F00;
	border-color: #F00;
	background-color: #700000;
}
</style>